import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlogBlockLink } from '../blog.models';

@Component({
  selector: 'app-blog-block-link',
  templateUrl: './block-link.component.html',
  styleUrls: ['./block-link.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogBlockLinkComponent {
  @Input({ required: true }) block!: BlogBlockLink;

  get target(): string | null {
    return this.block?.target === '_blank' ? '_blank' : null;
  }

  get rel(): string | null {
    return this.target ? 'noopener noreferrer' : null;
  }
}
